<section class="timeline">
  <div class="wrapper">
    <figure class="nue-logo">
      <img src="/assets/images/nue-logo.svg" alt="Nemzeti Ünnepek és Emléknapok" />
    </figure>
    <div class="timeline-box only-desktop">
      <span class="timeline-box-date start">Január</span>
      <ul class="timeline-lines">
        <ng-container *ngFor="let item of dates; let i = index">
          <li [matTooltip]="item.name" [matTooltipPosition]="'above'"
            [ngStyle]="{ left: item.position + '%', 'background-color': item.color }"
            [ngClass]="{ 'is-active': i === indexOfClosestDate }" class="timeline-lines-item">
            <a [routerLink]= "item?.slug ? ['/', 'nemzeti-unnep', item.slug] : []"><span [ngStyle]="{ 'background-color': item.color }" class="timeline-hover-item"></span></a>
          </li>
        </ng-container>
      </ul>
      <span class="timeline-box-date end">December</span>
    </div>
    <div class="timeline-box only-mobile">
      <ul class="mobile-timeline">
        <ng-container *ngFor="let item of dates">
          <li class="mobile-timeline-item">
            {{ item.date }} - <span class="mobile-timeline-name">{{ item.name }}</span>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</section>